module.exports = __webpack_public_path__ + "img/cross-error-red.107a5c0f.svg";